import { jsxs, jsx } from "react/jsx-runtime";
import { useTranslate } from "@bynder/localization";
function Inbox() {
  const { translate } = useTranslate();
  return /* @__PURE__ */ jsxs("div", { children: [
    /* @__PURE__ */ jsx("h1", { children: "Just testing out" }),
    /* @__PURE__ */ jsx("p", { children: translate("Cancel") })
  ] });
}
export {
  Inbox as default
};
//# sourceMappingURL=Inbox.js.map
